import {
  Alert,
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  Modal,
  Typography,
} from "@mui/material";
import {
  CONTENT_RATING,
  REJECTION_REASONS,
  REJECTION_REASON_KEY,
  style,
  TableSelect,
  URL_CONTENT_RATING_ID_KEY,
  URL_STATUS_KEY,
  URL_STATUS_PENDING,
} from "../../../utils/urlsTabsHelper";
import { bulkEditTitle, bulkSaveLabel, EPISODE_NOUN } from "./bulkUrlSelection";

const contentStyle = {
  ...style,
  width: { xs: "calc(100% - 32px)", sm: 576 },
  maxWidth: 576,
  height: "auto",
  maxHeight: "90vh",
  overflowY: "auto",
  p: { xs: 2, sm: 4 },
};

const BulkEditModal = ({
  open,
  onClose,
  onSave,
  onParamChange,
  saveEnabled,
  params,
  selectedCount = 0,
  noun = EPISODE_NOUN,
  saving = false,
  error = null,
}) => {
  const saveLabel = saving
    ? "Saving…"
    : bulkSaveLabel(selectedCount, noun, params[URL_STATUS_KEY]);

  return (
    <Modal
      open={open}
      onClose={() => {
        if (saving) return;
        onClose();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={contentStyle}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {bulkEditTitle(selectedCount, noun)}
        </Typography>
        <Typography
          id="modal-modal-description"
          variant="body2"
          color="text.secondary"
          sx={{ mt: 1, mb: 2 }}
        >
          {`${noun.other.charAt(0).toUpperCase()}${noun.other.slice(
            1
          )} you did not select stay pending.`}
        </Typography>
        {error ? (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        ) : null}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="bulk-edit-content-rating-label">
                Content Rating
              </InputLabel>
              <TableSelect
                items={CONTENT_RATING}
                labelId="bulk-edit-content-rating-label"
                label="Content Rating"
                onChange={onParamChange(URL_CONTENT_RATING_ID_KEY)}
                key={URL_CONTENT_RATING_ID_KEY}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="bulk-edit-status-label">Status</InputLabel>
              <TableSelect
                items={URL_STATUS_PENDING}
                labelId="bulk-edit-status-label"
                label="Status"
                onChange={onParamChange(URL_STATUS_KEY)}
                key={"url_status"}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl
              fullWidth
              size="small"
              disabled={params[URL_STATUS_KEY] !== "rejected"}
            >
              <InputLabel id="bulk-edit-rejection-reason-label">
                Rejection Reason
              </InputLabel>
              <TableSelect
                items={REJECTION_REASONS}
                labelId="bulk-edit-rejection-reason-label"
                label="Rejection Reason"
                disabled={params[URL_STATUS_KEY] !== "rejected"}
                onChange={onParamChange(REJECTION_REASON_KEY)}
                startingValue={
                  params[URL_STATUS_KEY] !== "rejected" ? "" : null
                }
                clearField={true}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} container justifyContent="flex-end" spacing={2}>
            <Grid item>
              <Button variant="text" onClick={onClose} disabled={saving}>
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="text"
                disabled={!saveEnabled || saving}
                onClick={onSave}
              >
                {saveLabel}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default BulkEditModal;
